export const SET_MODAL_OPEN = "SET_MODAL_OPEN";
export const SET_ERROR = "SET_ERROR";
export const SET_LOADING = "SET_LOADING";
export const REMOVE_LOADING = "REMOVE_LOADING";
export const SET_FILE_DATA = "SET_FILE_DATA";
export const SET_FILE_TYPE = "SET_FILE_TYPE";
export const SET_SORT_BY = "SET_SORT_BY";
export const SET_SHEETS = "SET_SHEETS";
export const SET_SEARCHED_SHEETS = "SET_SEARCHED_SHEETS";
export const REMOVE_SEARCHED_SHEETS = "REMOVE_SEARCHED_SHEETS";
export const SET_SHEET_DATA = "SET_SHEET_DATA";
export const UPDATE_SHEET_NAME = "UPDATE_SHEET_NAME";
export const UPDATE_SHEET_USERS = "UPDATE_SHEET_USERS";
export const USER_SIGNUP = "USER_SIGNUP";
export const USER_SIGNIN = "USER_SIGNIN";
export const GET_USER = "GET_USER";
export const USER_SIGNOUT = "USER_SIGNOUT";
export const SET_AUTH_ERROR = "SET_AUTH_ERROR";
